// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__goPB4","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__37c62"};